import React, { useState, useEffect } from 'react';
import './BookabilitySettings.css';

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const BookabilitySettings = () => {
  const [blockedWeekdays, setBlockedWeekdays] = useState([1, 2, 4]);
  const [practiceWeekdays, setPracticeWeekdays] = useState([3]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetch('/api/admin/config/bookability')
      .then(r => { if (!r.ok) throw new Error('Failed to load config'); return r.json(); })
      .then(data => {
        if (Array.isArray(data.blockedWeekdays)) setBlockedWeekdays(data.blockedWeekdays);
        if (Array.isArray(data.practiceWeekdays)) setPracticeWeekdays(data.practiceWeekdays);
      })
      .catch(e => console.error('Failed to load bookability config', e));
  }, []);

  const toggleBlocked = (day) => setBlockedWeekdays(prev =>
    prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
  );

  const togglePractice = (day) => setPracticeWeekdays(prev =>
    prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
  );

  const handleSave = () => {
    setSaving(true);
    fetch('/api/admin/config/bookability', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ blockedWeekdays, practiceWeekdays }),
    })
      .then(r => { if (!r.ok) throw new Error('Save failed'); return r.json(); })
      .then(data => {
        if (Array.isArray(data.blockedWeekdays)) setBlockedWeekdays(data.blockedWeekdays);
        if (Array.isArray(data.practiceWeekdays)) setPracticeWeekdays(data.practiceWeekdays);
      })
      .catch(e => alert('Error saving: ' + e.message))
      .finally(() => setSaving(false));
  };

  return (
    <div className="bookability-settings">
      <h3>Availability Settings</h3>
      <p className="bookability-hint">Blocked days are never shown as available to book.</p>
      <div className="weekday-toggles">
        {DAYS.map((name, idx) => (
          <button
            key={idx}
            className={'weekday-btn ' + (blockedWeekdays.includes(idx) ? 'blocked' : 'open')}
            onClick={() => toggleBlocked(idx)}
            type="button"
          >
            {name}
          </button>
        ))}
      </div>
      <p className="bookability-hint" style={{ marginTop: 12 }}>Practice days are shown as potential practice sessions.</p>
      <div className="weekday-toggles">
        {DAYS.map((name, idx) => (
          <button
            key={idx}
            className={'weekday-btn ' + (practiceWeekdays.includes(idx) ? 'practice' : 'open')}
            onClick={() => togglePractice(idx)}
            type="button"
          >
            {name}
          </button>
        ))}
      </div>
      <button className="save-btn" onClick={handleSave} disabled={saving}>
        {saving ? 'Saving...' : 'Save'}
      </button>
    </div>
  );
};

export default BookabilitySettings;
